import LocalOfferIcon from '@material-ui/icons/LocalOffer';

import List from './List';

export default { list: List, icon: LocalOfferIcon };
